import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { getSiteWidgetExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import {
  getExtensionRelativePaths,
  toPosix,
} from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const CUSTOM_ELEMENT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/custom-element'
);

export async function generateCustomElement(
  projectFolder: string,
  route: string,
  name: string,
  dashboardPageId?: string
) {
  const cwd = getSiteWidgetExtensionPath(projectFolder, route);
  const {
    relativePathToCodeFile,
    relativePathToConfigFile,
    relativePathToExtensionDir,
  } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: route,
    codeFileType: 'tsx',
  });

  const relativePathToSettingsFile = `./${toPosix(
    path.join(relativePathToExtensionDir, `${route}.panel.tsx`)
  )}`;
  const config = {
    id: randomUUID(),
    name,
    dashboardPageId,
    presetId: randomUUID(),
    element: relativePathToCodeFile,
    settings: relativePathToSettingsFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: CUSTOM_ELEMENT_TEMPLATE,
    assetsOutputPath: 'public',
    assetsPrefix: route,
    projectFolder,
    cwd,
    data: {
      route,
      config,
    },
  });
}
